/**
* Left Right JS
* -----------------------------------------------------------------------------
*
* All the JS for the Left Right component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'left-right',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.left-right' ).each( function() {
        const video = $( this ).find( '.loop-video' );
        const videoElement = video[0];
        const progressBar = $( this ).find( '#progressBar' );
        $( this ).find( '#left-right-video__button' ).on( 'click', function() {
          $( this ).toggleClass( 'not-muted' );
          if ( video.prop( 'muted' ) ) {
            video.prop( 'muted', false );
          } else {
            video.prop( 'muted', true );
          }
        } );
        video.on( 'timeupdate', function() {
          progressBar.attr( 'max', videoElement.duration );
          progressBar.val( videoElement.currentTime );
        } );

        progressBar.on( 'input', function() {
          videoElement.currentTime = $( this ).val();
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'left-right', COMPONENT );
} )( app );

